export const components = {
  Button: {
    baseStyle: {
      px: "5",
      py: "3",
      fontSize: "18px",
      fontWeight: 500,
      minWidth: "initial",
    },
    variants: {
      primary: {
        bg: "primary",
        color: "#ffffff",

        _disabled: {
          bg: "color.500",
          color: "white",
          _hover: {
            color: "primary",
          },
        },
      },
      secondary: {
        bg: "#ffffff",
        color: "primary",
        boxShadow:
          "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
      },
      tertiary: {
        bg: "secondary",
        color: "#ffffff",
      },
      transparent: {
        bg: "transparent",
      },
      error: {
        bg: "error",
        color: "white",
        px: "5",
        py: "3",
        fontSize: "16px",
        fontWeight: 500,
        minWidth: "initial",
      },
    },
    defaultProps: {
      variant: "primary",
    },
  },
  Modal: {
    baseStyle: () => ({
      overlay: {
        bg: "rgba(0,0,0,0.15)",
        backdropFilter: "blur(10px)",
      },
    }),
  },
  Drawer: {
    variants: {
      aside: {
        dialog: {
          pointerEvents: "auto",
        },
        dialogContainer: {
          pointerEvents: "none",
        },
      },
    },
    baseStyle: {
      overlay: {
        bg: "rgba(0,0,0,0.15)",
        backdropFilter: "blur(40px)",
      },
    },
  },
};
